export default function SeFooter() {
	return (
		<footer className="footer se-footer pt-4 pb-5 text-center">
			<h4>Instituto de Mediación Pedagógica</h4>
		</footer>
	)
}
